import postscribe from "postscribe";
export const mapScript = (element) => {
  postscribe(
    element,
    "<script src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script>"
  );
};

export const slightlyDifferent = (element) => {
  const scriptNode = document.createElement("script");
  scriptNode.innerHTML(`(function($) 
    {window.fnames = new Array(); window.ftypes = new Array();
    fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';
    fnames[4]='PHONE';ftypes[4]='phone';fnames[5]='BIRTHDAY';ftypes[5]='birthday';}(jQuery));
    var $mcj = jQuery.noConflict(true);`);
  element.appendChild(scriptNode);
};

export const getMCHtml = () => {
  const html = `<div id="mc_embed_signup">
        <form
          action="https://norlandiahjemmetjenester.us20.list-manage.com/subscribe/post?u=45d2767163356870d173a8d75&id=eb1f42c2a1"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          class="validate"
          target="_blank"
          novalidate
        >
          <div id="mc_embed_signup_scroll">
            <h2>MELD DEG PÅ VÅRT NYHETSBREV</h2>
            <div class="indicates-required">
              <span class="asterisk">*</span> indicates required
            </div>
            <div class="mc-field-group">
              <label for="mce-EMAIL">
                Email Address <span class="asterisk">*</span>
              </label>
              <input
                type="email"
                value=""
                name="EMAIL"
                class="required email"
                id="mce-EMAIL"
              />
            </div>
            <div id="mce-responses" class="clear foot">
              <div
                class="response"
                id="mce-error-response"
                style="display:none"
              ></div>
              <div
                class="response"
                id="mce-success-response"
                style="display:none"
              ></div>
            </div>
            <div style="position: absolute; left: -5000px;" aria-hidden="true">
              <input
                type="text"
                name="b_45d2767163356870d173a8d75_eb1f42c2a1"
                tabindex="-1"
                value=""
              />
            </div>
            <div class="optionalParent">
              <div class="clear foot">
                <input
                  type="submit"
                  value="Subscribe"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                  class="button"
                />
                <p class="brandingLogo" />
                <a
                  href="http://eepurl.com/hSnzcj"
                  title="Mailchimp - email marketing made easy and fun"
                />
                <img src="https://eep.io/mc-cdn-images/template_images/branding_logo_text_dark_dtp.svg" />
              </div>
            </div>
          </div>
        </form>
      </div>`;
  return html;
};
